import request from '@/plugins/request';
const env = import.meta.env.MODE;
import Cookies from 'js-cookie';

export function AccountPage (data: Record<string, any>,page: number,pageSize:number=20) {
    let token = Cookies.get("token");
    return request({
        url: `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/page?page=${page}&pageSize=${pageSize}`,
        method: 'post',
        headers:{Authorization: token,'Content-Type':'application/json'},
        data: {...data}
    });
}

export function AccountLogin (data: Record<string, any>) {
    return request({
        url: `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/oauth2/token`,
        method: 'post',
        headers:{Authorization: 'Basic MTIxOjRjYTJjMTQwNjQ4MzAzMWE3YzRkZjg0MDdj','Content-Type':'application/x-www-form-urlencoded'},
        data: {...data, 'grant_type':"urn:ietf:params:oauth:grant-type:password",scope:'userinfo'}
    });
}

export function refresh (refresh: string) {
    return request({
        url: `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/oauth2/token`,
        method: 'post',
        headers:{Authorization: 'Basic MTIxOjRjYTJjMTQwNjQ4MzAzMWE3YzRkZjg0MDdj','Content-Type':'application/x-www-form-urlencoded'},
        data: {"refresh_token":refresh, 'grant_type':"refresh_token",scope:'userinfo'}
    });
}

export function logout (token:string,type:number = 1) {
    return request({
        url: `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/oauth2/revoke`,
        method: 'post',
        headers:{Authorization: 'Basic MTIxOjRjYTJjMTQwNjQ4MzAzMWE3YzRkZjg0MDdj','Content-Type':'application/x-www-form-urlencoded'},
        data: {token:token,'token_type_hint':type == 1?'token':'refresh_token'}
    });
}

export function AccountRegister (data: Record<string, any>) {
    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/register`,
        method: 'post',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        data
    });
}
export function AccountLock (account:number,lock: boolean) {
    let token = Cookies.get("token");
    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/lock?a=${account}&l=${lock?0:1}`,
        method: 'get',
        headers:{'Authorization': token},
    });
}

export function AccountActive (account:string) {
    let token = Cookies.get("token");
    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/active?a=${account}`,
        method: 'get',
        headers:{'Authorization': token},
    });
}

export function AccountSetRole (account:string,role: string) {
    let token = Cookies.get("token");

    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/role/set?a=${account}&role=${role}`,
        method: 'get',
        headers:{'Authorization': token},
    });
}

export function AccountGetByEmail (email:string) {
    let token = Cookies.get("token");

    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/byEmail?e=${email}`,
        method: 'get',
        headers:{'Authorization': token},
    });
}

export function AccountUpdateEmail (data:any) {
    let token = Cookies.get("token");

    return request({
        url:  `${env == 'development' ? 'http://localhost:9000' :'https://api.onlylove.cc'}/account/updateEmail`,
        method: 'post',
        headers:{'Authorization': token},
        data
    });
}

export function ipAddr () {
    return request({
        url:  `https://ipapi.co/json`,
        method: 'get',
    });
}
